import { render, staticRenderFns } from "./update-parking-charge-rule.vue?vue&type=template&id=60c3296c&scoped=true"
import script from "./update-parking-charge-rule.vue?vue&type=script&lang=js"
export * from "./update-parking-charge-rule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c3296c",
  null
  
)

export default component.exports